<template>
  <lsm-widget
    width="full"
    borderless
  >
    <div class="d-flex flex-wrap flex-column ga-3 ma-n1">
      <div
        v-for="(alert, index) in alertMessages"
        :key="index"
      >
        <v-alert
          :type="alert.type"
          :icon="`fas fa-${alert.icon}`"
        >
          <rich-text-content
            class="text-start"
            :data="alert.message"
          />
        </v-alert>
      </div>
    </div>
  </lsm-widget>
</template>

<script setup lang="ts">
import RichTextContent from '@/components/rich-text/RichTextContent.vue';
import LsmWidget from './LsmWidget.vue';

withDefaults(defineProps<{
  alertMessages?: Array<App.Models.AlertMessage>;
}>(), {
  alertMessages: () => [],
});
</script>
